export default {
    // banner
    'career.banner.title': `Make fun make sense`,
    'career.banner.description': '欢迎加入我们！',
    'career.banner.buttonText': `浏览职位`,
    // content 1
    'career.content1.title': '关于我们',
    'career.content1.description': `我们相信：简单、坦诚、自驱、上进、分享、追求极致的氛围可以激发团队的活力与创造力`,
    // content 2
    'career.content2.1.title': 'Maria',
    'career.content2.1.subtitle': `Unity3D工程师`,
    'career.content2.1.description': `“在HABBY,能够和很多志同道合的小伙伴一起创造精品的游戏,让很多可能变成了现实！”`,
    'career.content2.2.title': 'Joel',
    'career.content2.2.subtitle': `产品运营`,
    'career.content2.2.description': `“我感受到HABBY与我曾经工作过的其他公司最大的不同之一就是,公司能够提供真正平等、自由、有爱、团结的工作氛围,并鼓励每个人发现自己更好的一面,成长为更好的自己！”`,
    // content 3
    'career.content3.title': '我们在哪',
    'career.content3.description': `Habby是一家全球化的精品游戏发行公司,目前在新加坡、北京、上海均设有分公司,未来还会不断开拓。`,
    'career.content3.location.1.title': '北京,中国',
    'career.content3.location.1.desc': '10 职位',
    'career.content3.location.2.title': '新加坡,新加坡',
    'career.content3.location.2.desc': '6 职位',
    // content 4
    'career.content4.modal.applyButtonText': '申请职位',
    'career.content4.title': '职位列表',
    'career.content4.description': `如果你想加入海彼,请将您的简历+申请职位发给我：简历接收邮箱：`,
    'career.content4.description.email': 'zhangxinzhe@habby.com',
    'career.content4.jobs.buttonText': '详情',
    'career.content4.jobs': [
        {
            title: '国内手游运营经理',
            location: '北京',
            type: '运营',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1、负责产品的发行和整体运营工作,制定相应的产品发行计划、运营实施规划、产品策略等,组织实施,对产品营收负责;\n2、负责规划手机游戏各阶段的线上线下活动以及活动专题的设计和制作,监督实施并进行效果报告统计分析;\n3、负责游戏产品数据分析,了解竞品对手产品市场信息,制定战略措施, 不断优化,打造产品核心竞争力;\n4、及时了解和分析用户情况、游戏在线运营情况,与研发、设计、测试团队协作,推动产品的开发、上线和版本迭代。'
                },
                {
                    title: '岗位要求',
                    content:
                        '1、全日制统招本科及以上学历,专业不限;\n2、5年及以上游戏运营相关工作经验,其中至少2年以上手游运营管理经验,国内海外地区不限;\n3、深入理解轻中度游戏优先,有策划经验优先,有Top50畅销游戏运营经验优先,有百万量级DAU游戏（不包含超休闲）运营经验优先;\n4、具备良好的沟通协调能力、项目管理能力及文案书写能力;\n5、具有较强的抗压精神和工作责任心,热爱游戏行业,期望长期在游戏行业发展。'
                }
            ]
        },
        {
            title: '游戏视频设计师',
            location: '北京',
            type: '视频设计',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1. 负责游戏买量视频制作，有极强创意输出；\n2.能够自主完成买量素材创意到输出；\n3.能够跟进市场投放情况，迅速总结经验优化素材方向；\n 4.可独立完成视频设计，具备后期制作和后期包装能力。'
                },
                {
                    title: '岗位要求',
                    content:
                        '1.专科以上学历，美术 影视 动画 游戏或数字媒体等相关专业毕业者优先；\n2. 有2年以上游戏视频制作经验；\n3. 有国内抖音 微博 微信等投放经验；\n4. 有休闲游戏买量经验，并有一定的方法论；\n5. 熟练使用AE 、premiere、ps，能够使用C4D、MAYA、3dMax其中的一种；\n6.积极主动，具备强烈的责任心，良好的抗压能力和耐心，较好的沟通能力。'
                }
            ]
        },
        {
            title: '资深游戏测试',
            location: '北京',
            type: '测试',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1、负责移动游戏产品测试，快速响应测试需求，保证测试业务有序开展；\n2、在测试过程中，迅速、准确、全面的找出游戏中的问题，并对问题产生原因做基本判断；\n3、熟悉项目开发及测试流程与各种测试技巧，熟悉测试用例及测试文档，测试报告的编写 ；\n5、研究测试技术、推动测试工具的设计研发，提升测试团队战斗力；'
                },
                {
                    title: '岗位要求',
                    content:
                        '1、计算机相关专业，本科及以上学历，5年及以上测试行业经验；\n2、有较强的逻辑分析能力和学习能力，自驱能力强，对项目质量负责，推动项目持续改进；\n3、良好的技术能力，至少熟练掌握一种编程语言；有技术热情，积极了解测试领域的技术进展；\n 4、 对游戏有足够热情，能够接受并投入各类游戏的测试工作；\n5、对个人看法能够精准描述；做事认真仔细、有耐心，踏实稳重，有良好的语言表达能力的协作沟通能力及逻辑思维能力，工作责任心强。'
                }
            ]
        },
        {
            title: '测试开发工程师',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1. 开发游戏自动化测试平台以及其他功能性测试平台\n2. 游戏UI自动化测试（Airtest + 游戏引擎）\n3. 游戏接口测试并且实现自动化（webscoket协议）\n4. 开发测试工具或二次开发其他测试工具，提高测试效率与满足可测性\n5. 编写测试用例并实现上述的自动化测试\n6. 移动端客户端性能测试（Perfdog以及游戏引擎调试工具）\n7. 服务器压力测试（基于游戏接口）\n8. SR安全测试（内存，接口，反编译等）\n9. 不断学习新的测试技术应用到生产中，实现测试生产力的跃进'
                },
                {
                    title: '岗位要求',
                    content:
                        '1. 985/211高校本科以上学历，计算机相关专业，游戏测试开发或游戏开发经验2年以上\n2. 熟悉或了解常见的游戏开发引擎（如Unity）\n3. 熟悉常见的数据结构与算法，熟悉sql\n4. 熟练使用C++, java, typescript , go,python中的一种或者多种进行开发\n5. 对网络协议,Http,Websocket,RPC有一定的了解\n6. 熟悉或了解后端的一些常用中间件，mysql,redis,docker等\n7. 对安卓系统与IOS系统有一定的了解\n 8. 有过大型游戏的测试开发经验或有对等着的版本迭代较快的情况下的自动化测试开发经验'
                }
            ]
        },
        {
            title: '游戏数值策划',
            location: '北京',
            type: '数值策划',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1、针对游戏的系统需求，以体验为核心，搭建游戏数值框架；\n2、围绕设计目的进行游戏的系统设计；\n3、培养团队新人。'
                },
                {
                    title: '职位要求',
                    content:
                        '1、至少有一款完整的手游项目上线经验，对游戏制作的各方面流程都有深入理解；\n2、有成功的欧美休闲手游项目研发或运营经验；\n3、3年以上系统或数值经验；\n4、有经营，养成类项目经验者优先；\n5、对游戏市场有深入的了解，能根据游戏的市场定位，目标用户进行完整的系统和数值架构设计；\n6、热爱游戏，游戏涉猎广，深入理解游戏的体验与交互；\n7、深度思考能力，有韧性。'
                }
            ]
        },
        {
            title: '游戏运营宣传设计师',
            location: '北京',
            type: '运营',
            descriptions: [
                {
                    title: '岗位描述',
                    content:
                        '1. 和运营团队紧密配合,讨论和推进创意,负责上线游戏的运营活动的物料设计\n2. 使用现有项目的美术资源,结合自身美术能力,表达创意,创作出不同场景需求使用的插图或者平面设计\n3. 根据结果总结积累经验,优化设计和效率\n4.与外包团队沟通协作,能独立把控外包设计质量和进度\n5.快速学习了解新的工具和方法,提升效率和质量,应用到实际项目'
                },
                {
                    title: '总体要求',
                    content:
                        '热情+自驱 + 高审美 + 有趣\n1. 审美好,创意能力强,做出能打动玩家的设计\n2. 具备出色的平面设计能力和一定的插画水准（辅助创意）,具备用不多的游戏资源设计出高品质运营宣传图的能力\n3. 擅长欧美卡通方向\n4. 强目标感,有明确追求的方向,对自己所做有高品质要求\n5. 自发推进,可以在一个开放自由的工作环境工作推进出好的结果\n6. 开放意识和心态,接受新的方法,工具和优化现有的工作模式\n7. 思维表达清晰,沟通简单高效且逻辑清楚\n8. 了解并熟悉常用AI绘图工具,如SD、MJ等\n9. 对游戏有着浓厚的热情,对Habby游戏有热情为佳'
                }
            ]
        },
        {
            title: '游戏高级UI设计师',
            location: '北京',
            type: '美术',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.负责游戏内UI界面的整体视觉设计包装；\n2.制定项目的UI风格；'
                },
                {
                    title: '任职要求',
                    content:
                        '1.有较好的平面设计基础，对市场流行的设计审美有成熟判断；\n2.优秀的团队协作能力，能顺滑的衔接与策划，交互，动效，还原，程序合作流程；\n3.优秀的绘制基础，优秀的图形设计，色彩构成，精修刻画能力；对游戏交互有较深理解；\n4.有较强的设计归纳总结能力，在工作中能有一定方法论沉淀，推动团队设计力进步；\n5.优秀的设计把控能力，对基础设计规范和资源输出管理有丰富经验；'
                }
            ]
        },
        {
            title: '3D主美/专家(偏重场景))',
            location: '北京',
            type: '主美',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1、使用u3d引擎根据需求独立完成游戏整体氛围的设计制作和效果的调整 ;\n2、负责游戏模型及贴图的制作，能够达到符合市场预期的品质；\n3、与策划，设计，技术等相关部门保持紧密的合作与沟通；\n4、了解动画，特效等其它环节者优先考虑 ;'
                },
                {
                    title: '岗位要求',
                    content:
                        '1、有5年以上的3D游戏制作工作经验；\n2、熟悉PBR制作流程及相关制作软件(PS，3DMAX/MAYA，Zb，SP等) ;\n3、熟练掌握Unity的材质，灯光，后处理等模块 ;\n4、能独立使用地图编辑器，完成模型和地编的制作 ;\n5、对环境和空间的布局有较强能力（对地貌，建筑，植被有很好的表现能力）；\n6、具备良好的沟通和团队合作能力；\n7、具备良好的自驱力,有自学能力及强烈的学习意愿；\n8、对于游戏开发充满激情，做事积极主动 ；'
                }
            ]
        },
        {
            title: '游戏原画师(角色+场景)',
            location: '北京',
            type: '游戏原画',
            descriptions: [
                {
                    title: '关键词',
                    content:
                        '欧美卡通、角色+场景、审美好、沟通好、思维跳跃、潮、对国外流行比较了解'
                },
                {
                    title: '总体要求',
                    content:
                        '1. 擅长欧美卡通方向，匹配欧美卡通项目风格\n2.强目标感，有明确追求的方向，对自己所做有品质的要求\n3.独立自主与项目成员沟通拆解需求，确定解决方案并且按时落地结果\n4.自发推进，在一个开放自由的工作环境工作并且对结果负责\n5.有任务管理和时间计划，可以并行安排好多不同优先级的任务需求\n6.开放意识和心态，接受新的方法和优化现有的工作模式\n7.思维表达清晰，沟通逻辑清楚\n8.有大公司和成功项目的经验优先，对游戏有着浓厚的热情，有自己对于游戏的理解，对Habby游戏有热情为佳'
                },
                {
                    title: '岗位要求',
                    content:
                        '1.3年以上游戏开发经验，和项目团队紧密配合，独立自主沟通拆解需求确定方案，在时间计划内完成角色和场景的原画设计，推进项目的设计进度\n2.和其他美术职能紧密配合，调试以寻求最佳呈现结果\n3.沟通简单顺畅，可以高效清晰讨论问题，开放思维，能接受不同意见\n4.有关于美术设计的方法论和经验，可以创造有趣且吸引人的角色，场景等游戏内的元素'
                }
            ]
        },
        {
            title: '游戏TA（美术向）',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1. 项目初期按照制作人要求搭建符合Demo风格的3D场景和角色效果(没有原画设计,只有需求描述);\n- 场景模型制作以及unity场景搭建, 材质调整和氛围调试 ;\n- 角色模型和贴图制作以及unity材质效果 ;\n- 配合策划和程序同学推进Demo的进度 ; \n2. 寻找符合的3D素材或者直接制作3D资源 ;\n3. 动作接入引擎(有动作同学帮助) ;\n4. 特效接入引擎(有特效同学帮助);'
                },
                {
                    title: '岗位要求',
                    content:
                        '1.配合项目Demo制作符合项目要求的美术资源\n2.负责Demo中的模型和材质制作'
                },
                {
                    title: '任职要求',
                    content:
                        '1.能够熟练使用unity的模型材质灯光等模块\n2.熟练掌握unity的shader编写(Build-in和URP) \n3.了解unity的动画和特效模块\n4.（有PBR制作能力或三渲二项目经验者优先）'
                },
                {
                    title: '总体要求',
                    content:
                        '1.擅长偏欧美卡通方向，审美高\n2.强目标感，有明确追求的方向，对自己产出有品质的要求\n3.自发推进，可以在一个开放自由的工作环境工作并且对结果负责\n4.开放意识和心态，接受新的方法和优化现有的工作模式\n5.思维表达清晰，沟通简单且逻辑清楚\n6.对游戏有着浓厚的热情，有自己对于游戏的理解，对Habby游戏有热情为佳'
                }
            ]
        },
        // Singapore
        {
            title: 'Game Artist',
            location: 'Singapore',
            type: 'Operator',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        '1.Develop the visual style, design, and overall look of the game.\n2.Create beautiful, engaging game characters, assets, and environments.\n3.Develop visual concepts and ideas, as well as creating 3D, 2D, VFX, and/or UI art for mobile games.\n4.Support the team in game design, working closely with programmers, community members, and everyone else on a tightly-knit game team.'
                },
                {
                    title: 'Requirements',
                    content:
                        '1.2-3 years of experience in mobile game development and game art design.\n2.A complete experience in mobile game development with Unity.\n3.Capability to independently create game concept art sketches, concept animations, and UI/UE, etc.\n4.Ability to create a variety of production-quality, Western-style game art.\n5.Modesty and respect when receiving feedback from your team.\n6.Passion for games, especially casual and mid-core games.\n7.Experience with 3D software and making 3D game art is a plus.\n8.Please include a portfolio as part of your application.'
                }
            ]
        },
        {
            title: 'Business Development Executive (Gaming)',
            location: 'Singapore',
            type: 'Business Development Executive (Gaming)',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        '1.Explore and maintain relationships with business partners to improve brand awareness;\n2.Collaborate with project teams (e.g. development or marketing teams) to come up with business strategies and plans;\n3.Attend gaming conferences and networking events to stay updated on industry trends and cultivate new business relationships;\n4.Work closely with external partners such as Google and Apple to ensure smooth execution of product launches and campaigns;\n5.Analyze market trends and competitive activity to set up effective business strategies;\n6.Actively seek out potential partnership opportunities and negotiate deals that are beneficial to the company.'
                },
                {
                    title: 'Requirements',
                    content: `1.Bachelor's degree or above in Business, Marketing, or any related field;\n2.Excellent verbal and written communication skills in English. Proficiency in Japanese or Korean is an advantage;\n3.Have at least 3 years of experience in gaming industry business development, sales, or account management;\n4.Deep understanding of the gaming industry, including its trends, players, and terminology;\n5.Ability to work in a fast-paced working environment;\n6.Excellent negotiation skills, interpersonal skills, and attention to detail;\n7.Excellent skills in reviewing contracts;\n8.Have a strong network in the gaming industry.`
                }
            ]
        },
        {
            title: 'Game Graphic Designer',
            location: 'Singapore',
            type: 'Designer',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        '1. Collaborate with the marketing team to conceptualize, design, and produce marketing materials for a variety of channels, including social media, marketing and advertising; \n2. Develop illustrations, graphic design, and others by software; \n3. Open to feedback and resolve design challenges; \n4. Ensure the finalized works are visually appealing and in line with the brand image; \n5. Optimize the process and efficiency based on cases and by new tools and methods; 6. Other duties as assigned.'
                },
                {
                    title: 'Requirements',
                    content:
                        '1. At least 2 years of graphic designing experience;\n2. A keen awareness for aesthetics and strong creativity to produce attractive visuals for players;\n3. A strong portfolio of illustrations or other graphic design works and able to create appealing graphics with limited resources;\n4. Familiar with the western game art style;\n5. Strong self-motivation and high self-demand; \n6. Excellent communication skills; \n7. Great passion for HABBY games is a plus.'
                }
            ]
        }
    ]
};
